/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Subject_TitleInputs */

const cs_gdpr_subject_title = /** @type {(inputs: Gdpr_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádost subjektu údajů`)
};

const en_gdpr_subject_title = /** @type {(inputs: Gdpr_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data subject request`)
};

/**
* | output |
* | --- |
* | "Data subject request" |
*
* @param {Gdpr_Subject_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_subject_title = /** @type {((inputs?: Gdpr_Subject_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Subject_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_subject_title(inputs)
	return cs_gdpr_subject_title(inputs)
});